import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { Card } from 'antd';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import getCauseById from '../../hooks/getCauseById';
import moment from 'moment';
import getCityById from '../../hooks/getCityById';
import useFetchStates from '../../hooks/fetchStates';
import useFetchCountries from '../../hooks/fetchCountries';
// const { MonthPicker, RangePicker } = DatePicker;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
const { TextArea } = Input;
const EditCity = () => {
  const { t } = useTranslation(['common']);
  const dateFormat = 'MM-DD-YYYY';
  const [uploadObj, setUploadObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [uploadedImg, setUploadedImg] = useState('');
  let user = JSON.parse(localStorage.getItem('user'));
  let cityId = JSON.parse(localStorage.getItem('cityId'));
  const s = useFetchStates();
  const states = s.response ? s.response.data : [];
  const c = useFetchCountries();
  const countries = c.response ? c.response.data : [];
  let ci = getCityById(cityId);
  console.log(ci);
  let cityObj = ci.response ? ci.response.data : null;
  console.log(cityObj);
  // let causeId=2
  // let ca = getCauseById(causeId);
  // let causeObj = ca.response ? ca.response.data : {};
  // if (causeObj.validityDate) console.log(causeObj.validityDate.split('T')[0]);
  // console.log(causeObj);
  // const o = useFetchOrganizations();
  // const orgs = o.response ? o.response.data : [];
  // console.log(orgs);
  // const cc = useFetchCauseCategories();
  // const causeCat = cc.response ? cc.response.data : [];
  // console.log(causeObj);
  // const c = useFetchCauseCategories();
  // console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  let navigate = useNavigate();
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      info.file ? setUploadedImg(info.file.response.data.Location) : ' ';
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  console.log(uploadedImg);
  // console.log(causeCat[0].cause_category);

  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/city/update/${cityId}`, uploadObj);
      window.alert(res.data.message);
      if (res.data.statusCode === 200) navigate('/city/view');
    } catch (err) {
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  };
  console.log(imageUrl);
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      name: values.name ? values.name : '',
      stateId: values.stateId ? values.stateId : '',
      countryId: values.countryId ? values.countryId : '',
      // image: uploadedImg? uploadedImg : causeObj.image,
      // validityDate: values.validityDate ? values.validityDate.format().split('T')[0] : causeObj.validityDate,
      isActive: values.isActive === true ? 1 : 0,
      // description: values.description ? values.description : '',
      updatedByUserId: user.userId,
    });
  };
  console.log(uploadObj);
  if (Object.keys(uploadObj).length > 0) uploadData(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const renderList = []; //For testing purposes
  return (
    <div className='col-lg-9 tbl p-4 mt-4'>
      <div className='fs-3 text-center mb-4 fw-bold'>{t('Update City')}</div>
      {ci.response ? (
        <Form
          name='basic'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
            ['name']: cityObj.name,
            ['stateId']: cityObj.stateId,
            ['countryId']: cityObj.countryId,
            ['isActive']: cityObj.isActive === 1 ? true : false,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Form.Item
            colon={false}
            label='City Name'
            name='name'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label='State'
            name='stateId'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              listHeight={250}
              listItemHeight={500}
              placeholder='Select'
              style={{
                width: 160,
              }}
            >
              {states.map((state) => {
                return (
                  <Option key={state.stateId} value={state.stateId}>
                    {state.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label='Country'
            name='countryId'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              listHeight={250}
              listItemHeight={500}
              placeholder='Select'
              style={{
                width: 160,
              }}
            >
              {countries.map((country) => {
                return (
                  <Option key={country.countryId} value={country.countryId}>
                    {country.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          {/* <Form.Item label='Image' name='image'>
              <Upload
                // name="avatar"
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={false}
                action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Form.Item> */}

          <Form.Item label='Active' valuePropName='checked' colon={false} name='isActive'>
            <Switch />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
            colon={false}
          >
            <button type='primary' class='btn btn-primary button' htmlType='submit'>
              Submit
            </button>
          </Form.Item>
        </Form>
      ) : (
        ' '
      )}
    </div>
  );
};

export default EditCity;
